import brand from "./brand";
import category from "./category";
import type from "./type";
import campaign from "./campaign";

export default [
  brand,
  category,
  type,
  campaign
]